import type { ComputedRef } from 'vue'
import type { LinkNavTab } from '@shared/ui/menus'

import { resolveUrl } from '@shared/lib/url'
import { AppRoute } from '@shared/config'

import { useKidPrivileges } from './kid-privileges.hook'

interface KidDetailMenuReturn {
  config: ComputedRef<LinkNavTab[]>
}

export const useKidDetailMenu = (): KidDetailMenuReturn => {
  const route = useRoute()
  const kidId = route.params.id as string
  const { canViewKids } = useKidPrivileges()

  const generalInfoUrl = resolveUrl(AppRoute.KidsShow, { id: kidId }) ?? ''
  const changelogUrl = resolveUrl(AppRoute.KidsChangelog, { id: kidId }) ?? ''

  const config = computed<LinkNavTab[]>(() => [
    {
      text: 'General info',
      to: generalInfoUrl,
      selected: route.path === generalInfoUrl,
      disabled: false,
      visible: canViewKids.value,
    },
    {
      text: 'Changelog',
      to: changelogUrl,
      selected: route.path === changelogUrl,
      disabled: false,
      visible: canViewKids.value,
    },
  ])

  return {
    config,
  }
}
